module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3bfb87273369a7962be885d2536a739c.gif";